<template>
  <div
    class="category column is-2"
  >
    <div class="category__name is-vertical-center jblock">
      <h4>{{ name }}</h4>
    </div>
    <div class="category__questions">
      <question
        v-for="(question, index) in category"
        :question="question"
        :key="question.id"
        :highlighted="highlighted && highlightedQuestionIndex === index"
        :class="{ 'is-highlighted': highlighted && highlightedQuestionIndex === index }"
      ></question>
    </div>
  </div>
</template>

<script>
  import EventBus from '@/EventBus';
  import Question from './Question.vue';

  export default {
    name: 'Category',

    props: {
      name: String,
      category: Array,
      highlighted: Boolean,
    },

    components: {
      Question,
    },

    data() {
      return {
        highlightedQuestionIndex: 0,
      };
    },

    created() {
      // we want to be able to listen outside the scope of being focused
      // on this category (so that we can maintain the same Q index for
      // all categories and not force user to click in this first)
      window.addEventListener('keyup', this.incHighlightedQuestion);
      window.addEventListener('keyup', this.decHighlightedQuestion);

      EventBus.$on('update-highlighted-question-index', this.updateHighlightedQuestion);
    },

    destroyed() {
      window.removeEventListener('keyup', this.incHighlightedQuestion);
      window.removeEventListener('keyup', this.decHighlightedQuestion);
    },

    methods: {
      incHighlightedQuestion(evt) {
        if (evt.key !== 'ArrowDown' || !this.highlighted) return;
        console.log('inc');
        this.highlightedQuestionIndex += 1;
        if (this.highlightedQuestionIndex > this.category.length - 1) {
          this.highlightedQuestionIndex = 0;
        }

        EventBus.$emit('update-highlighted-question-index', this.highlightedQuestionIndex);
      },

      decHighlightedQuestion(evt) {
        if (evt.key !== 'ArrowUp' || !this.highlighted) return;
        this.highlightedQuestionIndex -= 1;
        if (this.highlightedQuestionIndex < 0) {
          this.highlightedQuestionIndex = this.category.length - 1;
        }

        EventBus.$emit('update-highlighted-question-index', this.highlightedQuestionIndex);
      },

      updateHighlightedQuestion(index) {
        // this allows all categories to listen to the user navigation so they
        // can update the index as well, even when not highlighted
        if (index > this.category.length - 1) {
          this.highlightedQuestionIndex = this.category.length - 1;
        } else {
          this.highlightedQuestionIndex = index;
        }
      },

    },
  };
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
  $blue: rgb(6, 12, 234);

  .jblock {
    background-color: $blue;
    color: #FFFFFF;
    height: 16.66vh;
    text-align: center;

    border: 4px solid #000000;

    &.is-highlighted {
      border: 4px solid yellow;
    }

    h4 {
      font-size: 1rem;
      text-transform: uppercase;
      width: 100%;
    }
  }

  .category {
    padding-bottom: 0;
    padding-top: 0;

    h4 {
      font-family: Helvetica, sans-serif;
    }

    &__name {
      border-bottom: 6px solid #000000;
    }

    &__questions {
    }
  }

</style>
